// Libraries
import { Divider } from "@mui/material";

export default function SectionDivider() {
	return (
		<Divider
			sx={{
				marginTop: "24px",
				marginBottom: "24px",
				height: "0.25px",
			}}
			variant="fullWidth"
		/>
	);
}
